import { LayUpStatuses } from '@src/constants/LayupStatuses';
import useApi, { ApiOptions } from '../base/useApi';

export interface LayUpsDTO {
  layUps: LayUpsListsDTO[];
  consultants: LayUpsConsultantDTO[];
  operatingLists: LayUpOperatingListDTO[];
}

export interface LayUpsListsDTO {
  id: string;
  procedureDate: Date;
  status: LayUpStatuses;
  operatingListId: string;
  hasMissingItems: boolean;
  consultantId: string;
}

type LayUpsConsultantDTO = {
  id: string;
  title: string;
  firstName: string;
  lastName: string;
};

type LayUpOperatingListDTO = {
  id: string;
  name: string;
  code: string;
  order: number;
};

interface Params {
  hospitalId: string;
  fromDate: Date;
  status?: string;
}

type Result = LayUpsDTO;

const options: ApiOptions = {
  method: 'get',
  urlPath: '/layups',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useGetLayUpLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useGetLayUpLazy;
